export const formatCurrency = (amount) => {
  const num = Math.abs(Number(amount) || 0)
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)}Cr`
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)}L`
  if (num >= 1000) return `₹${(num / 1000).toFixed(1)}K`
  return `₹${num.toFixed(0)}`
}

export const formatAxisCurrency = (value) => {
  const num = Math.abs(Number(value) || 0)
  if (num >= 10000000) return `${(num / 10000000).toFixed(1)}Cr`
  if (num >= 100000) return `${(num / 100000).toFixed(1)}L`
  if (num >= 1000) return `${(num / 1000).toFixed(0)}K`
  return `${num.toFixed(0)}`
}

const formatDate = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const buildDateRange = ({ preset, customStartDate = '', customEndDate = '' }) => {
  const now = new Date()
  let from = null
  let to = null

  switch (preset) {
    case 'this-month':
    case 'current':
      from = new Date(now.getFullYear(), now.getMonth(), 1)
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      break
    case 'last-3-months':
    case 'last3months':
      from = new Date(now.getFullYear(), now.getMonth() - 3, 1)
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      break
    case 'last-6-months':
    case 'last6months':
      from = new Date(now.getFullYear(), now.getMonth() - 6, 1)
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      break
    case 'last-year':
    case 'lastyear':
      from = new Date(now.getFullYear() - 1, now.getMonth(), 1)
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      break
    case 'all-time':
    case 'all':
      break
    case 'custom':
      from = customStartDate ? new Date(customStartDate) : null
      to = customEndDate ? new Date(customEndDate) : null
      break
    default:
      from = new Date(now.getFullYear(), now.getMonth(), 1)
      to = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  }

  return {
    from: from ? formatDate(from) : null,
    to: to ? formatDate(to) : null,
  }
}

export const isCustomRangeIncomplete = (preset, customStartDate, customEndDate) =>
  preset === 'custom' && (!customStartDate || !customEndDate)

export const mapRevenueGraph = (graph = []) =>
  graph.map((item) => ({
    period: item.period,
    paid: Number(item.paid) || 0,
    due: Number(item.due ?? item.balance) || 0,
  }))

export const getGraphTitle = (granularity) => {
  switch (granularity) {
    case 'daily':
      return 'Revenue & Due Analysis (Daily)'
    case 'weekly':
      return 'Revenue & Due Analysis (Weekly)'
    case 'monthly':
      return 'Revenue & Due Analysis (Monthly)'
    default:
      return 'Revenue & Due Analysis'
  }
}
